import { EntityType } from '../../Model/Implementation/EntityType';
import { loadModuleDirectly } from '../../../@Util/DependencyInjection/Injection/DependencyInjection';
import { SettingSource, SettingStore } from '../../../@Component/Domain/Setting/SettingStore';
import { Setting } from '../../Settings/Setting';

export default function isHiddenType(type: EntityType)
{
    return loadModuleDirectly(SettingStore).getValue(SettingSource.Organization, Setting.Metadata.HiddenTypes)[type.id];
}
